<template>
<div class="basic-pagination">
    <ui-button color="default" type="normal" icon="keyboard_arrow_left" :disabled="meta.current_page<=1" @click="setPage(meta.current_page - 1)"></ui-button> Strona: <span>{{ meta.current_page }}</span> / <span>{{ meta.last_page }}</span>
    <ui-button color="default" type="normal" icon="keyboard_arrow_right" :disabled="meta.current_page>=meta.last_page" @click="setPage(meta.current_page + 1)"></ui-button>
    <span>Rekordów: {{ meta.total }}</span>
    <select name="limit" @change="setLimit">
      <option v-for="l in meta.limits">
        {{ l }}
      </option>
    </select>
</div>
</template>

<script>
export default {
  props: {
    meta: {
      type: Object,
      default: function () {
        return {
          current_page: 1,
          last_page: 0,
          total: 0,
          per_page: 10,
          limits: []
        }
      }
    }
  },
  data () {
    return {
      iconRight: true
    }
  },
  mounted () {
  },
  methods: {
    setLimit (e) {
      this.$emit('pagination-limit', e.currentTarget.value)
    },
    setPage (page) {
      this.$emit('pagination-page', page)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Basic.vue?45587fe6